import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-init-home',
  templateUrl: './init-home.component.html',
  styles: [
  ]
})
export class InitHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
